import { defineMessages } from 'react-intl';
import { number, object, ref } from 'yup';

const messages = defineMessages({
  minUsers: {
    id: 'configureTeam.minUsers',
    defaultMessage:
      'The number of users must be at least as many as the total number of iQ devices.',
  },
  maxDevices: {
    id: 'configureTeam.maxDevices',
    defaultMessage:
      'Too many devices. You cannot buy more than one iQ per user.',
  },
  minDevices: {
    id: 'configureTeam.minDevices',
    defaultMessage: 'You must select at least one iQ.',
  },
});

export default object({
  numCloudUsers: number().test('min', messages.minUsers, function test(value) {
    const numDevices =
      this.resolve(ref('numDevicesUsbC')) +
      this.resolve(ref('numDevicesLightning'));
    return (
      value == null ||
      numDevices > this.resolve(ref('$maxDevices')) ||
      value >= numDevices
    );
  }),

  numDevicesLightning: number()
    .test('max', messages.maxDevices, function test(value) {
      const numDevices =
        (this.resolve(ref('numDevicesUsbC')) || 0) +
        (this.resolve(ref('numDevicesLightning')) || 0);
      const numCloudUsers = this.resolve(ref('numCloudUsers'));
      return value == null || numDevices <= numCloudUsers;
    })
    .test('min', messages.minDevices, function test(value) {
      const numDevices =
        (this.resolve(ref('numDevicesUsbC')) || 0) +
        (this.resolve(ref('numDevicesLightning')) || 0);
      return value == null || numDevices > 0;
    }),

  numDevicesUsbC: number()
    .test('max', messages.maxDevices, function test(value) {
      const numDevices =
        (this.resolve(ref('numDevicesUsbC')) || 0) +
        (this.resolve(ref('numDevicesLightning')) || 0);
      const numCloudUsers = this.resolve(ref('numCloudUsers'));
      return value == null || numDevices <= numCloudUsers;
    })
    .test('min', messages.minDevices, function test(value) {
      const numDevices =
        (this.resolve(ref('numDevicesUsbC')) || 0) +
        (this.resolve(ref('numDevicesLightning')) || 0);
      return value == null || numDevices > 0;
    }),
});
